import { COFFEE_GEAR_PRODUCTS } from "./coffeeGearProducts";
import { COFFEE_BEANS_PRODUCTS } from "./coffeeBeansProducts";
import { GROUND_COFFEE_PRODUCTS } from "./groundCoffeeProducts";
import { INSTANT_COFFEE_PRODUCTS } from "./instantCoffeeProducts";
import { FLAVOURED_INSTANT_COFFEE_PRODUCTS } from "./flavouredInstantCoffeeProducts";

const values = (obj) => Object.values(obj || {});

export const STATIC_PRODUCTS = [
  ...values(INSTANT_COFFEE_PRODUCTS),
  ...values(FLAVOURED_INSTANT_COFFEE_PRODUCTS),
  ...values(GROUND_COFFEE_PRODUCTS),
  ...values(COFFEE_BEANS_PRODUCTS),
  ...values(COFFEE_GEAR_PRODUCTS),
];

